<template>
  <div class="coming-soon">
    <img class="image" src="@/assets/img/opponent-coming-soon.png">
  </div>
</template>

<script>
export default {
  name: 'coming-soon'
}
</script>

<style lang="scss" scoped>
.coming-soon {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.image {
  position: absolute;
  height: 125%;
  bottom: -26.5%;
  left: 75%;
  display: block;
  transform: translateX(-50%);
  opacity: 0.7;
}
</style>
